import * as React from "react";

import type { TooltipState } from "@fluentui/react-components";
import {
  useTooltipStyles_unstable,
  renderTooltip_unstable,
} from "@fluentui/react-components";
import type { AppTooltipProps } from "./AppTooltip.types";
import { useAppTooltip } from "./useAppTooltip";

export const AppTooltip: React.FC<AppTooltipProps> = React.memo(
  React.forwardRef<HTMLDivElement, AppTooltipProps>((props, _ref) => {
    const [visible, setVisible] = React.useState(false);
    const state = useAppTooltip(props, visible, setVisible);
    useTooltipStyles_unstable(state as TooltipState);
    return renderTooltip_unstable(state as TooltipState);
  })
);
